// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__EKPKx","leftColumn":"Layout_leftColumn__vAjQq","rightColumn":"Layout_rightColumn__rq5HP","view":"Layout_view__oMVug"};